export default __webpack_public_path__ + "static/usaid-dc8171c79d13c0683b6952ab9d69c5c8.png";